module["exports"] = [
  "Australia"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_au_ocker/address/default_country.js
 ** module id = 465
 ** module chunks = 0
 **/